import type {
  ModerationTab,
  ReportStatus,
  ReportTargetType,
  ShouttModerationState,
  ShouttStatus,
  ShouttType,
} from '@/types/moderation.types';

export const MODERATION_TABS: ReadonlyArray<{ key: ModerationTab; label: string }> = [
  { key: 'all', label: 'All Queue' },
  { key: 'ai_flagged', label: '🤖 AI Flagged' },
  { key: 'reported', label: '🚨 Reported' },
  { key: 'removed', label: '🗑️ Removed' },
  { key: 'reports', label: '🚩 Reports Queue' },
];

/** Tabs backed by the /admin/shoutts endpoint (vs. the AI-flagged / reports queues). */
export const SHOUTT_TABS: ReadonlyArray<ModerationTab> = ['all', 'reported', 'removed'];

type Tone = 'brand' | 'success' | 'info' | 'warn' | 'danger' | 'pink' | 'neutral';

export const SHOUTT_TYPE_PILL: Record<ShouttType, { label: string; tone: Tone }> = {
  ask: { label: 'Ask', tone: 'info' },
  offer: { label: 'Offer', tone: 'brand' },
  team: { label: 'Team Up', tone: 'pink' },
  community: { label: 'Community Request', tone: 'info' },
};

export const SHOUTT_STATUS_PILL: Record<ShouttStatus, { label: string; tone: Tone }> = {
  active: { label: 'Live', tone: 'success' },
  expired: { label: 'Expired', tone: 'neutral' },
  closed: { label: 'Closed', tone: 'neutral' },
  removed: { label: 'Removed', tone: 'danger' },
};

export const MODERATION_STATE_PILL: Record<ShouttModerationState, { label: string; tone: Tone }> = {
  approved: { label: 'Approved', tone: 'success' },
  pending: { label: 'Pending Review', tone: 'warn' },
  rejected: { label: 'Rejected', tone: 'danger' },
};

export const REPORT_STATUS_PILL: Record<ReportStatus, { label: string; tone: Tone }> = {
  open: { label: 'Open', tone: 'danger' },
  reviewing: { label: 'Reviewing', tone: 'warn' },
  resolved: { label: 'Resolved', tone: 'success' },
};

export const REPORT_TARGET_PILL: Record<ReportTargetType, { label: string; tone: Tone }> = {
  user: { label: '👤 User', tone: 'pink' },
  listing: { label: '📦 Listing', tone: 'brand' },
  shoutt: { label: '📣 Shoutt', tone: 'info' },
};

export const REPORT_STATUS_FILTERS: ReadonlyArray<{ key: ReportStatus | ''; label: string }> = [
  { key: '', label: 'All statuses' },
  { key: 'open', label: 'Open' },
  { key: 'reviewing', label: 'Reviewing' },
  { key: 'resolved', label: 'Resolved' },
];

export const PAGE_SIZE = 12;
